import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HelpModalModule } from 'Angular/features/components/modals/help-modal/help-modal.module';
import { DisabledModule } from 'Angular/features/directives/disabled/disabled.module';
import { IconModule } from 'Angular/features/directives/icon/icon.module';
import { TooltipModule } from 'Angular/features/directives/popovers/tooltip/tooltip.module';
import * as i0 from "@angular/core";
export class CascadingDropdownModule {
}
CascadingDropdownModule.ɵfac = function CascadingDropdownModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || CascadingDropdownModule)(); };
CascadingDropdownModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: CascadingDropdownModule });
CascadingDropdownModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule, DisabledModule, IconModule, TooltipModule, FormsModule, HelpModalModule] });
